import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {Subscription} from 'rxjs';
import {Select, SelectChangeEvent} from 'primeng/select';
import {FormsModule} from '@angular/forms';
import {DirectusLoader, Language} from '@frontend/directus';
import {UserlaneService} from '../../../services/userlane.service';

@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  imports: [Select, FormsModule],
})
export class LanguageDropdownComponent implements OnInit, OnDestroy {
  private readonly directusLoader = inject(DirectusLoader);
  private readonly translocoService = inject(TranslocoService);
  private readonly userlaneService = inject(UserlaneService);

  languageOptions: {label: string; value: string}[] = [];
  selectedLanguage: string | undefined;
  private langSub: Subscription | undefined;

  ngOnInit(): void {
    this.selectedLanguage = this.translocoService.getActiveLang();
    this.updateLanguageOptions();
    this.langSub = this.translocoService.langChanges$.subscribe((activeLang: string) => {
      this.updateLanguageOptions();
      this.selectedLanguage = activeLang;
    });
  }

  updateLanguageOptions(): void {
    const activeLang = this.translocoService.getActiveLang();
    this.languageOptions = this.directusLoader.availableLanguages.map((lang: Language) => ({
      label:
        lang.code.toUpperCase() || lang.localized_name[activeLang] || lang.localized_name['en'],
      value: lang.code,
    }));
  }

  onLanguageChange(event: SelectChangeEvent): void {
    const newLang = event.value;
    this.translocoService.setActiveLang(newLang);
    this.userlaneService.setLanguage(newLang);
    localStorage.setItem('transloco-lang', newLang);
  }

  ngOnDestroy(): void {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }
}
